import React from 'react';

import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg3 app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <h1 className="headtext__cormorant">Chief Editors Notes</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">It brings us great joy to announce the latest edition of RETROSPECT.</p>
        </div>
        <p className="p__opensans"> The team has worked tirelessly over the past few months to capture the memories, ideals, hopes and dreams of the hundreds of Singaporean undergradutes at Imperial between 2019 and 2022. We hope that you have a good read! </p>
      </div>

      <div className="app__chef-sign">
        <p>Wayne Yeo | Yui Harayama</p>
        <p className="p__opensans">Chief Editors</p>
        <img src={images.sign} alt="sign_image" />
      </div>
    </div>
  </div>
);

export default Chef;
